import $ from 'jquery';
import 'jquery-ui';
import "slick-carousel";
import './map';
import {isString} from "extract-text-webpack-plugin/dist/lib/helpers";

let hurtList = {};
let cookieServicesData = {};
var obo = obo || {
    results: [],
};

function modalCookieCategories() {
    let html = '';
    html += getCookieCategories('essential');
    html += getCookieCategories('marketing');
    $('#cookie-details-categories').html(html);
}
function getCookieCategories(category) {
    let cookieCategories = '',
      cookieCategoriesContent = '',
      count = 0,
      switchCategories = '';

    cookieCategoriesContent += '<div class="cookie-details-item-content">';
    $.each(cookieData, (cookieKey, cookieValue) => {
        let swichService = '';
        if (cookieValue.category === category) {
            let status = readCookie('obo-' + cookieValue.id);

            if (cookieServicesData[cookieValue.id] === undefined) {
                cookieServicesData[cookieValue.id] = status;
            }

            if (status === '1') {
                switchCategories = ' active-switch';
                swichService = ' active-switch';
            }
            if (category === 'essential') {
                switchCategories = ' frozen-switch';
                swichService = ' frozen-switch';
            }
            cookieCategoriesContent += '' +
                '<div class="service-info-row">\n' +
                '    <div class="service-info-title">\n' +
                '        '+ cookieValue.name +'\n' +
                '    </div>\n' +
                '    <div class="service-info-actions">\n' +
                '        <div class="service-info-icon" data-service-id="'+ cookieValue.id +'">\n' +
                '            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">\n' +
                '                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>\n' +
                '                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>\n' +
                '            </svg>\n' +
                '        </div>\n' +
                '        <div class="service-info-switch' + swichService + '" data-switch-id="'+ cookieValue.id +'" data-switch-category="'+ cookieValue.category +'">\n' +
                '            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">\n' +
                '                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>\n' +
                '            </svg>\n' +
                '            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">\n' +
                '                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>\n' +
                '            </svg>\n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>';
            count++;
        }
    });
    cookieCategoriesContent += '</div>'; // cookie-details-item-content

    cookieCategories += '<div class="cookie-details-item">' +
      '<div class="cookie-details-item-headline">\n' +
      '    <div class="cookie-details-item-title">\n' +
      '        ' + cookieKeyTranslate[category] + '\n' +
      '        <small>' + cookieInfoTranslate[category] + '</small>\n' +
      '    </div>\n' +
      '    <div class="cookie-details-item-actions">\n' +
      '        <div class="cookie-details-item-switch category-switch' + switchCategories + '" data-switch-id="'+ category +'" data-switch-category="'+ category +'">\n' +
      '            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">\n' +
      '                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>\n' +
      '            </svg>\n' +
      '            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">\n' +
      '                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>\n' +
      '            </svg>\n' +
      '        </div>\n' +
      '        <div class="cookie-details-item-collapse">\n' +
      '            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">\n' +
      '                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>\n' +
      '            </svg>\n' +
      '        </div>\n' +
      '    </div>\n' +
      '</div>';

    cookieCategories += cookieCategoriesContent + '</div>'; // cookie-details-item

    if (count > 0) {
        return cookieCategories;
    } else {
        return '';
    }
}
function modalCookieServices() {
    let html = '';
    html += getCookieServices('essential');
    html += getCookieServices('marketing');
    $('#cookie-details-services').html(html);
}
function getCookieServices(category) {
    let cookieServices = '',
        count = 0;

    $.each(cookieData, (cookieKey, cookieValue) => {
        if (cookieValue.category === category) {
            let swichService = '';
            let status = readCookie('obo-' + cookieValue.id);
            if (status === '1') {
                swichService = ' active-switch';
            }
            if (category === 'essential') {
                swichService = ' frozen-switch';
                if (status !== '1') {
                    createCookie('obo-' + cookieValue.id, '1', 30);
                }
            }
            cookieServices += '<div class="cookie-details-item" id="service-detail-' + cookieValue.id + '">' +
                '<div class="cookie-details-item-headline">\n' +
                '    <div class="cookie-details-item-title">\n' +
                '        ' + cookieValue.name + '\n' +
                '        <small>' + cookieKeyTranslate[cookieValue.category] + '</small>\n' +
                '    </div>\n' +
                '    <div class="cookie-details-item-actions">\n' +
                '        <div class="cookie-details-item-switch' + swichService + '" data-switch-id="'+ cookieValue.id +'" data-switch-category="'+ cookieValue.category +'">\n' +
                '            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">\n' +
                '                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>\n' +
                '            </svg>\n' +
                '            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">\n' +
                '                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>\n' +
                '            </svg>\n' +
                '        </div>\n' +
                '        <div class="cookie-details-item-collapse">\n' +
                '            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">\n' +
                '                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>\n' +
                '            </svg>\n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>';

            cookieServices += '<div class="cookie-details-item-content">';

            $.each(cookieValue, (cookieServiceKey, cookieServiceValue) => {
                if (cookieServiceKey !== 'id' && cookieServiceKey !== 'name' && cookieServiceKey !== 'category') {
                    let tmpItemVal = '';
                    cookieServices += '' +
                        '<p>\n' +
                        '    <span class="cookie-subtitle">' + cookieKeyTranslate[cookieServiceKey] + '</span>\n';
                    if (cookieKeyTranslate[cookieServiceKey + 'Description']) {
                        cookieServices += '' +
                            '<span class="cookie-subtitle-desc">' + cookieKeyTranslate[cookieServiceKey + 'Description'] + '</span>\n';
                    }

                    if (Array.isArray(cookieServiceValue)) {
                        $.each(cookieServiceValue, (itemKey, itemValue) => {
                            count++;
                            if (cookieServiceKey === 'processingLocation' || cookieServiceKey === 'dataStoragePeriod' ||
                                cookieServiceKey === 'storageInformation') { // list
                                tmpItemVal += '<span class="cookie-list">' + itemValue + '</span>';
                            } else if (cookieServiceKey === 'dataRecipients') { // dataRecipients is Obj
                                if (itemValue['dataRecipient']) {
                                    tmpItemVal += '<span class="cookie-tag">' + itemValue['dataRecipient'] + '</span><br /><br />';
                                }
                                if (itemValue['policy']) {
                                    tmpItemVal += cookieKeyTranslate['policy'] + '<br /><a href="' + itemValue['policy'] + '" target="_blank">' + itemValue['policy'] + '</a><br /><br />';
                                }
                                if (itemValue['policyCookie']) {
                                    tmpItemVal += cookieKeyTranslate['policyCookie'] + '<br /><a href="' + itemValue['policyCookie'] + '" target="_blank">' + itemValue['policyCookie'] + '</a><br /><br />';
                                }
                                if (itemValue['optOut']) {
                                    tmpItemVal += cookieKeyTranslate['optOut'] + '<br /><a href="' + itemValue['optOut'] + '" target="_blank">' + itemValue['optOut'] + '</a>';
                                }
                            } else { // tag
                                tmpItemVal += '<span class="cookie-tag">' + itemValue + '</span>';
                            }
                        });
                    } else {
                        count++;
                        if (cookieServiceKey === 'ido') {
                            tmpItemVal += '<a href="' + cookieServiceValue + '" target="_blank">' + cookieServiceValue + '</a>';
                        } else {
                            tmpItemVal += cookieServiceValue;
                        }
                    }
                    cookieServices += tmpItemVal;
                    cookieServices += '</p>\n';
                }
            });

            cookieServices += '</div>'; // cookie-details-item-content
            cookieServices += '</div>'; // cookie-details-item
        }
    });

    if (count > 0) {
        return cookieServices;
    } else {
        return '';
    }
}
function saveCookieDecision() {
    const date = new Date();
    const dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )).toISOString().split('.');
    createCookie('obo-cookie-decision-date', dateString[0].replace('T', ' '), 30);
    window.location.reload();
}

$(document).ready(function () {

    if ( $('.gallery').length !== 0) {
        let $gallery = $('.gallery').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<div class="gallery-arrow gallery-arrow-left">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">\n' +
              '  <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>\n' +
              '</svg>' +
              '</div>',
            nextArrow:' <div class="gallery-arrow gallery-arrow-right">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">\n' +
              '  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>\n' +
              '</svg>' +
              '</div>',
            arrows: true,
            fade: false,
            touchMove: false,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
            ]
        });
    }

    modalCookieCategories();
    modalCookieServices();

    let status = readCookie('obo-cookie-decision-date');
    if (cookieServicesData['obo-cookie-decision-date'] === undefined) {
        cookieServicesData['obo-cookie-decision-date'] = status;
    }

    if (status === null) {
        showModalCookie();
    } else {
        turnOnThirdPartScripts()
    }

    $('#cookie-privacy').on('click', function () {
        showModalCookie();
    });

    $('#cookie-details-categories').hide();
    $('#cookie-details-services').hide();

    $('#cookie-btn-settings').on('click', function () {
        $('.cookie-info').hide();
        $('.cookie-info-settings').show();
    });

    $('#cookie-tab-categories').on('click', function (el) {
        el = $(el.target);
        el.addClass('active-tab');
        $('#cookie-tab-services').removeClass('active-tab');
        $('#cookie-details-categories').show();
        $('#cookie-details-services').hide();
    });

    $('#cookie-tab-services').on('click', function (el) {
        el = $(el.target);
        el.addClass('active-tab');
        $('#cookie-tab-categories').removeClass('active-tab');
        $('#cookie-details-categories').hide();
        $('#cookie-details-services').show();
    });

    $('#cookie-tab-categories').click();

    $('.cookie-info').show();
    $('.cookie-info-settings').hide();

    $('.cookie-details-item-headline').on('click', function (el) {
        el = $(el.target).parent();
        if (el.hasClass('is-open')) {
            el.removeClass('is-open');
        } else {
            el.addClass('is-open');
        }
    });

    $('.cookie-details-item-switch').on('click', function (el) {
        el = $(el.target);
        const switchId = el.data('switch-id'),
            switchCategory = el.data('switch-category');

        if (switchCategory === 'essential') return;

        if (el.hasClass('category-switch')) {
            if (el.hasClass('active-switch')) {
                el.removeClass('active-switch');
                $('#cookie-details-categories').find("[data-switch-category='" +  switchCategory + "']").removeClass('active-switch');
                $('#cookie-details-services').find("[data-switch-category='" +  switchCategory + "']").removeClass('active-switch');
            } else {
                el.addClass('active-switch');
                $('#cookie-details-categories').find("[data-switch-category='" +  switchCategory + "']").addClass('active-switch');
                $('#cookie-details-services').find("[data-switch-category='" +  switchCategory + "']").addClass('active-switch');
            }
        } else {
            if (el.hasClass('active-switch')) {
                el.removeClass('active-switch');
                $('#cookie-details-categories').find("[data-switch-id='" +  el.data('switch-id') + "']").removeClass('active-switch');

                if ($('#cookie-details-categories').find(".service-info-switch.active-switch[data-switch-category='" +  switchCategory + "']").length === 0) {
                    $('#cookie-details-categories .cookie-details-item-headline').find("[data-switch-category='" +  switchCategory + "']").removeClass('active-switch');
                }
            } else {
                el.addClass('active-switch');
                $('#cookie-details-categories').find("[data-switch-id='" +  el.data('switch-id') + "']").addClass('active-switch');
                $('#cookie-details-categories .cookie-details-item-headline').find("[data-switch-category='" +  switchCategory + "']").addClass('active-switch');
            }
        }
    });

    $('.service-info-switch').on('click', function (el) {
        el = $(el.target);
        const switchId = el.data('switch-id'),
            switchCategory = el.data('switch-category');

        if (switchCategory === 'essential') return;

        if (el.hasClass('active-switch')) {
            el.removeClass('active-switch');
            $('#cookie-details-services').find("[data-switch-id='" +  el.data('switch-id') + "']").removeClass('active-switch');
            if ($('#cookie-details-categories').find(".service-info-switch.active-switch[data-switch-category='" +  switchCategory + "']").length === 0) {
                $('#cookie-details-categories .cookie-details-item-headline').find("[data-switch-category='" +  switchCategory + "']").removeClass('active-switch');
            }
        } else {
            el.addClass('active-switch');
            $('#cookie-details-services').find("[data-switch-id='" +  el.data('switch-id') + "']").addClass('active-switch');
            $('#cookie-details-categories .cookie-details-item-headline').find("[data-switch-category='" +  switchCategory + "']").addClass('active-switch');
        }
    });

    $('#cookie-btn-save-selected').on('click', function (el) {
       const cookieServices = $('#cookie-details-services').find('.cookie-details-item-switch');
        $.each(cookieServices, (itemKey, itemValue) => {
            if ($(itemValue).hasClass('active-switch')) {
                createCookie('obo-' + $(itemValue).data('switch-id'), '1', 30);
            } else {
                if (!$(itemValue).hasClass('frozen-switch')) {
                    deleteCookie('obo-' + $(itemValue).data('switch-id'));
                }
            }
        });
        saveCookieDecision();
    });

    $('#cookie-btn-allow-all').on('click', function (el) {
        const cookieServices = $('#cookie-details-services').find('.cookie-details-item-switch');
        $.each(cookieServices, (itemKey, itemValue) => {
            createCookie('obo-' + $(itemValue).data('switch-id'), '1', 30);
        });
        saveCookieDecision();
    });

    $('#cookie-btn-not-allowed-all').on('click', function (el) {
        const cookieServices = $('#cookie-details-services').find('.cookie-details-item-switch');
        $.each(cookieServices, (itemKey, itemValue) => {
            if (!$(itemValue).hasClass('frozen-switch')) {
                deleteCookie('obo-' + $(itemValue).data('switch-id'));
            }
        });
        saveCookieDecision();
    });

    $('.service-info-icon').on('click', function (el) {
        el = $(el.target).parent();
        $('#cookie-tab-services').click();
        const target = $('#service-detail-' + el.data('service-id'));
        target.addClass('is-open');
        const topPos = target.position().top;

        $('.modal-box-content').animate({
            scrollTop: topPos + 100
        }, 100);
    });

    $('#modal-btn-close').on('click', function () {
        $('.cookie-info').show();
        $('.cookie-info-settings').hide();
    });

    $('#btn-hamburger-open').on('click', function () {
        $('.nav-menu').addClass('show-menu');
    });

    $('#btn-hamburger-close').on('click', function () {
        $('.nav-menu').removeClass('show-menu');
    });

    $('.dialog-box-close').click(function(){
        $('#dialog').hide();
    });

    $('#borough').on('change', function() {
        if ($('#search-input').val() !== '') {
            $('#form-1').submit();
        }
    });

    $('#checkbox-selling-online').on('change', function() {
        if ($('#search-input').val() !== '') {
            $('#form-1').submit();
        }
    });

    $(document).on('keyup', function(e) {
        if (e.key === "Escape") {
            $('#dialog').hide();
        }
    });

    $(document).on('click', function(e) {
        if (e.target.id !== 'search-input') {
            $('#box-suggest').fadeOut(100);
        }
    });

    $('#search-input').on('keyup', function(e) {
        if ($('#search-input').val().length > 2 && e.key !== "Enter") {
            searchInputMatch($('#search-input').val());
        } else {
            $('#box-suggest').fadeOut(100);
        }
    } );

    $('#form-1').submit((e) => {
        e.preventDefault();
        const items = $('#box-suggest').children();
        let search = '',
            searchNrKat = '';
        if (items.length > 0) {
            const item =  $(items[0]);
            $.each(items, (k, v) => {
                if ($(v).data('name') === $('#search-input').val()) {
                    searchNrKat = $(v).data('nrkat');
                    search = $(v).data('name');
                    return false;
                } else {
                    searchNrKat = item.data('nrkat');
                    search = item.data('name');
                }
            });
            $('#search-input').val(search);
        } else {
            searchNrKat = $('#search-input').val();
        }
        $('#box-suggest').fadeOut(100);
        getProduct(searchNrKat, $('#borough').val(), $('#checkbox-selling-online').is(':checked'));
    });

    hurtList = appData.hurtList;
});

function showModalCookie() {
    $('#modal-cookie').addClass('show-modal');
    openModal();
}
function closeModalCookie() {
    $('#modal-cookie').removeClass('show-modal');
    closeModal();
}

function openModal() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('no-scroll');
}
function closeModal() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('no-scroll');
}

function searchInputMatch(val) {
    const items = appData.simpleProductList,
        reg = new RegExp(val, 'gi');
    let text = '',
        isFound = false,
        boxSuggest = $('#box-suggest');

    $.each(items, (k, v) => {
        let name = v.nazwa + ' - ' + v.symbol + ' - ' + v.nr_kat + '';
        if (v.nazwa && name.match(reg)){
            const search = new RegExp(val, 'gi');
            text += '<div class="suggest-item" data-name="'+ name + '" data-nrkat="'+ v.nr_kat + '">' +
                name.replace(search, "<strong>$&</strong>")  +
                '</div>';
            isFound = true;
        }
    });

    if (isFound) {
        boxSuggest.html(text);
        boxSuggest.fadeIn(100);

        setTimeout(() => {
            $('.suggest-item').click(function(){
                $('#search-input').val($(this).data('name'));
                boxSuggest.fadeOut(100);
                $('#form-1').submit();
            });
        }, 300);
    } else {
        boxSuggest.html(text);
        boxSuggest.fadeOut(100);
    }
}

function showDetails(id) {
    let value = getValueByKey(hurtList, id);
    let text = '<p>' + value.nazwa + '</p>';
    text += '<p>' + value.a_adres + '</p>';
    text += '<p>' + value.a_kod + ' ' + value.a_miejsc + '</p>';
    if (value.tel1) {
        text += '<p>Telefon: ' + value.tel1 + '</p>';
    }
    if (value.tel2) {
        text += '<p>Telefon: ' + value.tel2 + '</p>';
    }
    if (value.email) {
        text += '<p>E-mail: <a href="mailto:' + value.email + '">' + value.email + '</a></p>';
    }
    if (value.www) {
        text += '<p>WWW: <a href="' + value.www + '" target="_blank">' + value.www + '</a></p>';
    }

    $('.dialog .dialog-box .dialog-box-body .dialog-box-description').html(text);
    $('#dialog').show();
}


function showResults(status, data, idBorough, sellingOnline) {
    let sectionInformations = $('#section-informations'),
        sectionResults = $('#section-results'),
        sectionLoader = $('#section-loader'),
        sectionError = $('#section-error'),
        sectionMap = $('#section-map'),
        sectionDownload = $('#section-download'),
        tmpResults = [];

    sectionInformations.hide();
    sectionDownload.hide();
    sectionLoader.hide();

    if (status === 'success' && data.length > 0) {
        obo.results = [];

        if (data.length > 0) {
            fillDownloadBox(data[0]);
        }

        $.each(data, (k, v) => {
            let valueHurt = getValueByKey(hurtList, v.rp_hurt1_id);
            if (idBorough !== '0') {
                if (idBorough === valueHurt.a_teryt.slice(0, 2)) {
                    tmpResults.push(v);
                }
            } else {
                tmpResults.push(v);
            }
        });

        obo.results = tmpResults;
        tmpResults = [];

        if (sellingOnline && obo.results.length > 0) {
            $.each(obo.results, (k, v) => {
                let valueHurt = getValueByKey(hurtList, v.rp_hurt1_id);
                if (v.sklep_url !== null && valueHurt.typ === 'C') {
                    tmpResults.push(v);
                }
            });
            obo.results = tmpResults;
        }

        if (obo.results.length > 0) {
            sortResults('desc', 'ilosc1');
            fillResultsTable(obo.results);
            sectionMap.show();
        } else {
            obo.results = [];
            sectionResults.hide();
            $('.go-to-map').hide();
            $('#section-map').hide();
            sectionError.show();
            sectionMap.hide();
        }
    } else {
        obo.results = [];
        sectionResults.hide();
        sectionError.show();
        sectionMap.hide();
    }
}

function sortResults(sort, key) {
    if (sort === 'desc') {
        obo.results.sort((a, b) => b[key] - a[key]);
    } else {
        obo.results.sort((a, b) => a[key] - b[key]);
    }
}

function fillDownloadBox(item) {
    let sectionDownload = $('#section-download');
    let html = '';
    if (item.dekl_zg !== null && item.dekl_zg !== undefined) {
        html += '<a href="' + item.dekl_zg + '" type="button" target="_blank" class="btn-download">Deklaracja Zgodności</a>';
    }
    if (item.karta_k !== null && item.karta_k !== undefined) {
        html += '<a href="' + item.karta_k + '" type="button" target="_blank" class="btn-download">Karta katalogowa</a>';
    }
    if (item.cert_ro !== null && item.cert_ro !== undefined) {
        html += '<a href="' + item.cert_ro + '" type="button" target="_blank" class="btn-download">Certyfikat ROHS</a>';
    }

    if (html.length > 0) {
        html = '<h2>Do Pobrania</h2><p>' + item.nazwa + '<br /><span>(' + item.symbol + ')</span></p>' +
            '<div class="download-box">' + html + '</div>';
        $('#download-buttons').html(html);
        sectionDownload.show();
    }
}

function fillResultsTable(data) {
    let sectionResults = $('#section-results'),
        markersData = [],
        marker = {}

    let table = '<table>\n' +
        '                <tr class="table-header">\n' +
        '                    <th>Nazwa<br />(Symbol)</th>\n' +
        '                    <th>Ilość</th>\n' +
        '                    <th>Ostatnia aktualizacja</th>\n' +
        '                    <th>Miejsce składowania</th>\n' +
        '                </tr>';

    $.each(data, (k, v) => {
        let valueHurt = getValueByKey(hurtList, v.rp_hurt1_id),
            thumbail = '';
        if (v.zdjecie !== null) {
            let imgName = v.zdjecie.split('/');
            if (imgName[imgName.length - 1]) {
                imgName = imgName[imgName.length - 1];
                thumbail = '<img src="https://www.obo.pl/out/pictures/generated/product/1/68_68_75/' + imgName + '" />';
            }
        }
        table += '<tr>\n' +
            '                    <td><div class="td-thumbail">' + thumbail + '<span>' + v.nazwa + '<br />(' + v.symbol + ')</span></div></td>\n' +
            '                    <td>' + v.ilosc1 + ' ' + v.jedn_m + '</td>\n' +
            '                    <td>' + v.data_akt + '</td>\n' +
            '                    <td>' + valueHurt.nazwa + '<br />' + valueHurt.a_adres + ' <br />' + valueHurt.a_kod + ' ' + valueHurt.a_miejsc + '' +
            '<div class="button-info">' +
            '<button type="button" class="btn-contact btn-show-dialog" data-hurt-id="' + v.rp_hurt1_id + '">Kontakt</button>';

        if (valueHurt.latitude && valueHurt.longitude) {
            let contentTmp = '<p>Ilość: ' + v.ilosc1 + ' ' + v.jedn_m + '</p><p>' + valueHurt.nazwa +
              '<br />' + valueHurt.a_adres + ' <br />' + valueHurt.a_kod + ' ' + valueHurt.a_miejsc + '</p>';

            if (valueHurt.tel1) {
                contentTmp += '<p>Telefon: ' + valueHurt.tel1 + '</p>';
            }
            if (valueHurt.tel2) {
                contentTmp += '<p>Telefon: ' + valueHurt.tel2 + '</p>';
            }
            if (valueHurt.email) {
                contentTmp += '<p>E-mail: <a href="mailto:' + valueHurt.email + '">' + valueHurt.email + '</a></p>';
            }
            if (v.sklep_url && valueHurt.typ === 'C') {
                contentTmp += '<p><a href="' + v.sklep_url + '" target="_blank" class="marker-link-contact">Strona WWW</a></p>';
            }

            const mapDestination = (valueHurt.nazwa + ', ' + valueHurt.a_adres + ' ' + valueHurt.a_kod + '%2C' + valueHurt.a_miejsc)
              .replaceAll(' ', '+');
            contentTmp += '<a class="map-info-btn" href="https://www.google.com/maps/dir/?api=1&destination=' + mapDestination + '" target="_blank">Wyznacz trasę</a>';

            marker = {
                lat: valueHurt.latitude,
                lng: valueHurt.longitude,
                content: contentTmp
            };

            markersData.push(marker);
            marker = {};
        }
        if (v.sklep_url && valueHurt.typ === 'C') {
            if (typeof v.sklep_url === 'string') {
                table += '<a href="' + v.sklep_url + '" target="_blank"  type="button" class="btn-contact">Strona WWW</a>';
            } else if (typeof v.sklep_url === 'object' && Object.getOwnPropertyNames(v.sklep_url).length > 0) {
                Object.entries(v.sklep_url).forEach(([name, url]) => {
                    table += '<a href="' + url + '" target="_blank"  type="button" class="btn-contact">' + name + '</a>';
                });
            }
        }
        table += '</div>' +
            '</td>\n' +
            '</tr>';
    });

    table += '</table>';
    $('#table-results').html(table);

    if (window.map !== undefined) {
        addMarkers(markersData);
        $('.go-to-map').show();
        $('#section-map').show();
    }

    sectionResults.show();

    setTimeout(() => {
        $('.btn-show-dialog').click(function(){
            showDetails($(this).data('hurt-id'));
        });
    }, 300);
}

function getProduct(id, idBorough = '0', sellingOnline = false) {
    let sectionSearch = $('#section-search'),
        sectionInformations = $('#section-informations'),
        sectionResults = $('#section-results'),
        sectionError = $('#section-error'),
        sectionLoader = $('#section-loader'),
        sectionDownload = $('#section-download'),
        sectionVisual = $('#section-visual');

    $('#table-results').html('');
    sectionInformations.hide();
    sectionResults.hide();
    sectionSearch.addClass('section-filters');
    sectionVisual.addClass('visual-filters');
    sectionError.hide();
    sectionDownload.hide();
    sectionLoader.show();

    let jqxhr = $.get( '/search/' + id, function(data) {
    })
        .done(function(data) {
            setTimeout(() => {
                showResults('success', data, idBorough, sellingOnline);
                if (typeof gtag !== 'undefined') {
                    if (data && data.length > 0) {
                        const eventCategory = 'event',
                            eventLabel = 'search',
                            nrKat = data[0]['nr_kat'],
                            symbol = data[0]['symbol'];
                        gtag(eventCategory, eventLabel, {
                            'nr_kat': nrKat,
                            'symbol': symbol,
                        });
                    } else {
                        const eventCategory = 'event',
                            eventLabel = 'empty_search',
                            nrKat = id;
                        gtag(eventCategory, eventLabel, {
                            'nr_kat': nrKat,
                        });
                    }
                }
                sectionLoader.hide();
            }, 300);
        })
        .fail(function() {
            showResults('error', idBorough, sellingOnline);
            sectionLoader.hide();
        })
}

function getValueByKey(data, value) {
    let val = {};
    $.each(data, (k, v) => {
        if (v.rp_hurt1_id === value) {
            val = v;
        }
    });
    return val;
}

// Cookies

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function deleteCookie(name) {
    createCookie(name, "", -1);
}

function turnOnThirdPartScripts() {
    if (cookieServicesData['google_tag_manager'] === '1' && cookieServicesData['google_analytics'] === '1' && gtmKey) {
        let newScript = document.createElement('script');
        newScript.async = true;
        newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtmKey;
        document.head.appendChild(newScript);

        newScript = document.createElement('script');
        newScript.text = '' +
            'window.dataLayer = window.dataLayer || [];\n' +
            'function gtag(){dataLayer.push(arguments);}\n' +
            'gtag(\'js\', new Date());\n' +
            '\n' +
            'gtag(\'config\', \'' + gtmKey + '\');';
        document.head.appendChild(newScript);
    }
}

const cookieData = [
    {
        id: 'google_maps',
        name: 'Google Maps',
        category: 'essential', // essential, marketing, functional
        // Opis usługi
        description: 'Jest to zintegrowana usługa mapowa.',
        //Firma przetwarzająca
        company: 'Google LLC<br />1600 Amphitheatre Parkway Mountain View, CA 94043, United States of America',
        // Inspektor ochrony danych firmy przetwarzającej
        ido: 'https://support.google.com/policies/contact/general_privacy_form',
        // Cele dot. danych
        purposes: ['Wyświetlanie map'],
        // Wykorzystywane technologie
        technology: ['Interfejsy API'],
        // Zebrane dane
        dataCollected: ['Data i godzina wizyty','Informacje o lokalizacji','Adres IP','Adres URL','Dane o użytkowaniu aplikacji','Terminy wyszukiwania','Lokalizacja geograficzna'],
        // Podstawa prawna
        legalBasis: ['Art. 6. ust. 1 s. 1 lit. a RODO'],
        // Lokalizacja przetwarzania
        processingLocation: ['Unia Europejska'],
        // Okres przechowywania informacji
        dataStoragePeriod: ['Dane zostaną usunięte, gdy tylko przestaną być niezbędne do celów przetwarzania.'],
        // Przekazywanie do innych państw
        transferToOtherCountries: ['Stany Zjednoczone Ameryki','Singapur','Chile','Tajwan'],
        // Odbiorcy danych
        dataRecipients: [
            {
                dataRecipient: 'Google Ireland Limited, Google LLC, Alphabet Inc',
                policy: 'http://www.google.com/intl/de/policies/privacy',
                policyCookie: 'https://policies.google.com/technologies/cookies?hl=en',
                // rezygnacja z podmiotu przetwarzającego dane we wszystkich domenach
                optOut: ''
            }
        ],
        // Informacje dotyczące przechowywania
        storageInformation: ['Maximum age of cookie storage: 2 Lata','Non-cookie storage: no']
    },
    {
        id: 'google_fonts',
        name: 'Google Fonts',
        category: 'essential', // essential, marketing, functional
        // Opis usługi
        description: 'Jest to zbiór czcionek do użytku komercyjnego i osobistego.',
        //Firma przetwarzająca
        company: 'Google Ireland Limited<br />Gordon House, 4 Barrow St, Dublin 4, Ireland',
        // Inspektor ochrony danych firmy przetwarzającej
        ido: 'https://support.google.com/policies/contact/general_privacy_form',
        // Cele dot. danych
        purposes: ['Dostarczanie czcionek','Poprawa usług'],
        // Wykorzystywane technologie
        technology: ['Interfejsy API'],
        // Zebrane dane
        dataCollected: ['Adres IP', 'Zagregowane numery użytkowania', 'Żądania plików czcionek', 'Referrer URL', 'Żądania pliku CSS', 'Agent użytkownika', 'Informacje o przeglądarce '],
        // Podstawa prawna
        legalBasis: ['Art. 6. ust. 1 s. 1 lit. a RODO'],
        // Lokalizacja przetwarzania
        processingLocation: ['Unia Europejska'],
        // Okres przechowywania informacji
        dataStoragePeriod: ['Dane zostaną usunięte, gdy tylko przestaną być niezbędne do celów przetwarzania.'],
        // Przekazywanie do innych państw
        transferToOtherCountries: ['Stany Zjednoczone Ameryki','Singapur','Chile','Tajwan'],
        // Odbiorcy danych
        dataRecipients: [
            {
                dataRecipient: 'Alphabet Inc., Google LLC, Google Ireland Limited',
                policy: 'https://business.safety.google/privacy/?hl=en',
                policyCookie: 'https://policies.google.com/technologies/cookies?hl=en',
            }
        ],
        // // Informacje dotyczące przechowywania
        // storageInformation: ['Maximum age of cookie storage: 2 Lata','Non-cookie storage: no']
    },
    {
        id: 'google_tag_manager',
        name: 'Google Tag Manager',
        category: 'marketing', // essential, marketing, functional
        // Opis usługi
        description: 'To jest system zarządzania tagami. Za pomocą Menedżera tagów Google tagi można integrować centralnie za pośrednictwem interfejsu użytkownika. Tagi to małe sekcje kodu, które mogą śledzić działania. Kody skryptów innych narzędzi są integrowane za pośrednictwem Menedżera tagów Google. Menedżer tagów pozwala kontrolować, kiedy dany tag jest wyzwalany.',
        //Firma przetwarzająca
        company: 'Google Ireland Limited<br />Google Building Gordon House, 4 Barrow St, Dublin, D04 E5W5, Ireland',
        // Inspektor ochrony danych firmy przetwarzającej
        ido: 'https://support.google.com/policies/contact/general_privacy_form',
        // Cele dot. danych
        purposes: ['Zarządzanie znacznikami'],
        // Wykorzystywane technologie
        technology: ['Znaczniki witryny'],
        // Zebrane dane
        dataCollected: ['Globalne dane o uruchamianiu tagów'],
        // Podstawa prawna
        legalBasis: ['Art. 6. ust. 1 s. 1 lit. a RODO'],
        // Lokalizacja przetwarzania
        processingLocation: ['Unia Europejska'],
        // Okres przechowywania informacji
        dataStoragePeriod: ['Dane zostaną usunięte, gdy tylko przestaną być niezbędne do celów przetwarzania.'],
        // Przekazywanie do innych państw
        transferToOtherCountries: ['Stany Zjednoczone Ameryki','Singapur','Chile','Tajwan'],
        // Odbiorcy danych
        dataRecipients: [
            {
                dataRecipient: 'Alphabet Inc., Google LLC, Google Ireland Limited',
                policy: 'https://business.safety.google/privacy/?hl=en',
                policyCookie: 'https://policies.google.com/technologies/cookies?hl=en',
            }
        ],
        // // Informacje dotyczące przechowywania
        // storageInformation: ['Maximum age of cookie storage: 2 Lata','Non-cookie storage: no']
    },
    {
        id: 'google_analytics',
        name: 'Google Analytics',
        category: 'marketing', // essential, marketing, functional
        // Opis usługi
        description: 'To jest usługa analityki internetowej. Dzięki temu użytkownik może mierzyć zwrot z inwestycji reklamowej „ROI”, a także śledzić zachowanie użytkownika za pomocą flasha, wideo, stron internetowych i aplikacji.',
        //Firma przetwarzająca
        company: 'Google Ireland Limited<br />Google Building Gordon House, 4 Barrow St, Dublin, D04 E5W5, Ireland',
        // Inspektor ochrony danych firmy przetwarzającej
        ido: 'https://support.google.com/policies/contact/general_privacy_form',
        // Cele dot. danych
        purposes: ['Marketing','Analizy'],
        // Wykorzystywane technologie
        technology: ['Cookies','Pixel','JavaScript'],
        // Zebrane dane
        dataCollected: ['Kliknij ścieżkę', 'Data i godzina wizyty', 'Informacje o urządzeniu', 'Informacje o lokalizacji',
            'Adres IP', 'Odwiedzone strony', 'Referrer URL', 'Informacje o przeglądarce', 'Nazwa hosta', 'Język przeglądarki',
            'Typ przeglądarki', 'Rozdzielczość ekranu', 'System operacyjny urządzenia', 'Dane interakcji', 'Zachowanie użytkownika', 'Odwiedzone adresy URL', 'Identyfikator plików cookie'],
        // Podstawa prawna
        legalBasis: ['Art. 6. ust. 1 s. 1 lit. a RODO'],
        // Lokalizacja przetwarzania
        processingLocation: ['Unia Europejska'],
        // Okres przechowywania informacji
        dataStoragePeriod: ['Okres przechowywania zależy od rodzaju zapisanych danych. Każdy użytkownik może wybrać, jak długo Google Analytics ma przechowywać dane przed ich automatycznym usunięciem.'],
        // Przekazywanie do innych państw
        transferToOtherCountries: ['Stany Zjednoczone Ameryki','Singapur','Chile','Tajwan'],
        // Odbiorcy danych
        dataRecipients: [
            {
                dataRecipient: 'Google Ireland Limited, Alphabet Inc., Google LLC',
                policy: 'https://policies.google.com/privacy?hl=en',
                policyCookie: 'https://policies.google.com/technologies/cookies?hl=en',
                // rezygnacja z podmiotu przetwarzającego dane we wszystkich domenach
                optOut: 'https://tools.google.com/dlpage/gaoptout?hl=de'
            }
        ],
        // Informacje dotyczące przechowywania
        storageInformation: ['Maximum age of cookie storage: 2 Lata','Non-cookie storage: no']
    },
    // {
    //     id: '',
    //     name: '',
    //     category: '', // essential, marketing, functional
    //     // Opis usługi
    //     description: '',
    //     //Firma przetwarzająca
    //     company: '',
    //     // Inspektor ochrony danych firmy przetwarzającej
    //     ido: '',
    //     // Cele dot. danych
    //     purposes: [],
    //     // Wykorzystywane technologie
    //     technology: [],
    //     // Zebrane dane
    //     dataCollected: [],
    //     // Podstawa prawna
    //     legalBasis: [],
    //     // Lokalizacja przetwarzania
    //     processingLocation: [],
    //     // Okres przechowywania informacji
    //     dataStoragePeriod: [],
    //     // Przekazywanie do innych państw
    //     transferToOtherCountries: [],
    //     // Odbiorcy danych
    //     dataRecipients: [
    //         {
    //             dataRecipient: '',
    //             policy: '',
    //             policyCookie: '',
    //             // rezygnacja z podmiotu przetwarzającego dane we wszystkich domenach
    //             optOut: ''
    //         }
    //     ],
    //     // Informacje dotyczące przechowywania
    //     storageInformation: []
    // },
];

const cookieKeyTranslate = {
    id: 'id',
    name: 'Nazwa',
    category: 'Kategoria',
    description: 'Opis usługi',
    company: 'Firma przetwarzająca',
    ido: 'Inspektor ochrony danych firmy przetwarzającej',
    idoDescription: 'Poniżej znajduje się adres e-mail inspektora ochrony danych firmy przetwarzającej.',
    purposes: 'Cele dot. danych',
    purposesDescription: 'Ta lista przedstawia cele zbierania i przetwarzania danych.',
    technology: 'Wykorzystywane technologie',
    technologyDescription: 'Ta lista przedstawia wszystkie technologie wykorzystywane przez tę usługę do gromadzenia danych. Typowe technologie to pliki cookie i piksele, które są umieszczane w przeglądarce.',
    dataCollected: 'Zebrane dane',
    dataCollectedDescription: 'Ta lista przedstawia wszystkie (osobiste) dane gromadzone przez tę usługę lub za jej pośrednictwem.',
    legalBasis: 'Podstawa prawna',
    legalBasisDescription: 'Poniżej wymieniono wymagane podstawy prawne dotyczące przetwarzania danych.',
    processingLocation: 'Lokalizacja przetwarzania',
    processingLocationDescription: 'Jest to główna lokalizacja, w której przetwarzane są zebrane dane. Jeśli dane są przetwarzane również w innych krajach, użytkownik jest informowany osobno.',
    dataStoragePeriod: 'Okres przechowywania informacji',
    dataStoragePeriodDescription: 'Okres przechowywania to przedział czasu, w którym zebrane dane są zapisywane w celu przetwarzania. Dane należy usunąć, gdy tylko nie będą już potrzebne do określonych celów przetwarzania.',
    transferToOtherCountries: 'Przekazywanie do innych państw',
    transferToOtherCountriesDescription: 'Ta usługa może przekazywać zebrane dane do innego kraju. Należy pamiętać, że ta usługa może przekazywać dane do kraju, w którym nie obowiązują wymagane standardy ochrony danych. Poniżej znajduje się lista krajów, do których dane są przekazywane. Aby uzyskać więcej informacji na temat zabezpieczeń, zapoznaj się z polityką prywatności dostawcy lub skontaktuj się z nim bezpośrednio.',
    dataRecipients: 'Odbiorcy danych',
    dataRecipientsDescription: 'Poniżej wymieniono odbiorców gromadzonych danych.',
    dataRecipient: 'Odbiorca danych',
    policy: 'Kliknij tutaj, aby przeczytać politykę prywatności podmiotu przetwarzającego dane',
    policyCookie: 'Kliknij tutaj, aby przeczytać politykę plików cookie podmiotu przetwarzającego dane',
    optOut: 'Kliknij tutaj, aby zrezygnować z tego podmiotu przetwarzającego dane we wszystkich domenach',
    storageInformation: 'Informacje dotyczące przechowywania',
    storageInformationDescription: 'Poniżej możesz zobaczyć, jaki jest najdłuższy potencjalny czas przechowywania informacji w urządzeniu, określony z wykorzystaniem metody przechowywania plików cookie, oraz dowiedzieć się, czy stosowane są inne metody.',
    essential: 'Kluczowy',
    marketing: 'Marketing',
    functional: 'Funkcjonalne',
}
const cookieInfoTranslate = {
    essential: 'Technologie te są wymagane do aktywacji podstawowej funkcjonalności strony.',
    marketing: 'Technologie te są wykorzystywane przez reklamodawców do wyświetlania reklam odpowiadających ich zainteresowaniom.',
    functional: 'Technologie te pozwalają nam analizować wykorzystanie strony internetowej do pomiaru i poprawy wydajności.',
}
